const vinIdentificationData = state => state.vinIdentificationData;
const mileage = state => state.mileage;
const hsnTsnData = state => state.hsnTsnData;
const prevRoutes = state => state.prevRoutes;

export default {
  vinIdentificationData,
  mileage,
  hsnTsnData,
  prevRoutes
}
